<template>
  <div class="toast" ref="toast">
    <span>{{message}}</span>
  </div>
</template>

<script>
  export default {
    props: {
      duration: [String, Number]
    },
    data: () => ({
      message: '',
    }),
    methods: {
      toggle: function(message) {
        this.message = message;
        clearTimeout(this.timeout);
        const duration = parseFloat(this.duration);
        this.timeout = setTimeout(() => {
          this.toast.removeAttribute('toggle');
        }, duration);
        if (this.toast.getAttribute('toggle') !== '') {
          this.toast.setAttribute('toggle', '');
          return;
        }
        this.toast.removeAttribute('toggle');
        setTimeout(() => {
          this.toast.setAttribute('toggle', '');
        }, 200);
      },
    },
    mounted: function() {
      this.toast = this.$refs.toast;
    }
  }
</script>

<style lang="scss" scoped>
  .toast {
    position: fixed;
    left: 24px;
    bottom: 24px;
    margin: auto;
    padding: 0 24px;
    display: flex;
    align-items: center;
    background-color: #323232;
    border-radius: 4px;
    color: #fff;
    font-size: 15px;
    box-shadow: 0 3px 5px -1px rgba(0,0,0,0.2), 0 6px 10px 0 rgba(0,0,0,0.14), 0 1px 18px 0 rgba(0,0,0,0.12);
    will-change: transform;
    transition: 150ms transform ease;
    z-index: 5;
    min-height: 52px;
    min-width: 288px;
    transform: translateY(100px);
    opacity: 0;
    transition: 250ms transform ease, 200ms opacity ease;

    &[toggle] {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @media screen and (max-width: 720px) {
    .toast {
      bottom: 0;
      left: 0;
      width: 100%;
      border-radius: 0;
    }
  }
</style>